export default __webpack_public_path__ + "static/media/CommonInternetWhalingAttacks3.283913b1.jpg";